export default __webpack_public_path__ + "static/media/undraw_compose_music_ovo2.4fe6d339.svg";